<!--
 * @Author: your name
 * @Date: 2021-06-22 11:35:34
 * @LastEditTime: 2021-07-13 10:14:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolMedia.vue
-->
<!--流媒体-->

<template>
  <div class="tool-media">
    <img class="field-media"  :class="{'scale-type':!media.ext_val_scaleType}"  src="@/assets/images/program/program_media_img.png" alt />
  </div>
</template>

<script>
export default {
  name: "ToolMedia",
    props: {
    media: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-media {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .field-media {
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: contain;
  }
  .scale-type {
    object-fit: fill;
  }
}
</style>